import { useState } from 'react';
import { FormContainer } from '../../../_core/form/form-container.component';
import { EditMemberNestedContainer, IEditMemberContainerProps } from './edit-member-form-nested.container';
import { ICloseableDialogProps } from '../../../_core/core.types';

export const EditMemberContainer = (props: IEditMemberContainerProps & ICloseableDialogProps) => {
  const [success, setSuccess] = useState<string | null>(null);
  const [submitError, setSubmitError] = useState<string | null>(null);

  return (
    <FormContainer
      error={submitError}
      setError={setSubmitError}
      success={success}
      setSuccess={setSuccess}
      title="Edit Staff Member"
    >
      <EditMemberNestedContainer
        {...props}
        onError={(e) => setSubmitError(e ?? null)}
        onSuccess={(s) => setSuccess(s ?? null)}
      />
    </FormContainer>
  );
};
